import React from 'react';
import { PrimaryButton } from '@fluentui/react';

interface AppWelcomeButtonsProps {
    onUpdatesClick?: () => void;
    onInsightsClick?: () => void;
    updatesButtonText?: string;
    updatesButtonStyle?: React.CSSProperties;
    insightsButtonStyle?: React.CSSProperties;
}

export const AppWelcomeButtons: React.FC<AppWelcomeButtonsProps> = ({
    updatesButtonText,
    onUpdatesClick,
    onInsightsClick,
    updatesButtonStyle,
    insightsButtonStyle
}) => {
    return (
        <div className="welcomescreen-button-container">
            {onUpdatesClick && (
                <PrimaryButton
                    text={updatesButtonText ?? 'Start / View Updates'}
                    className="button"
                    onClick={onUpdatesClick}
                    style={updatesButtonStyle}
                />
            )}
            {onInsightsClick && (
                <PrimaryButton
                    text="View Insights"
                    className="button"
                    onClick={onInsightsClick}
                    style={insightsButtonStyle}
                />
            )}
        </div>
    );
};
